import React, { useState } from "react";
import '../../../assets/css/Unavbar.css'
import { Link, useNavigate } from "react-router-dom";
import bless from '../../../assets/images/bless.png'
import CartSlider from "../../CartSlider/CartSliderBar"; // Import cart slider
import { FaShoppingCart } from "react-icons/fa"; // Import cart icon
import { useCart } from "../../CartContext/CartContextComp"; // Import cart context

const BlessnavBar = () => {
  const navigate = useNavigate();
  const { cartItems } = useCart(); // Get cart items
  const [cartOpen, setCartOpen] = useState(false); // Control cart slider visibility

  const handleContactClick = (e) => {
    e.preventDefault(); // Prevent default anchor behavior

    navigate("/bless#bcontact");

    setTimeout(() => {
      const contactSection = document.getElementById("bcontact");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); // Small delay to ensure navigation happens first
  };

  return (
    <nav className="navbar">
      <div className="ulogo">
        <Link to="/bless">
          <img
            src={bless}
            alt="Logo"
            className="ulogo-image"
          />
        </Link>
      </div>
      <div className="nav-links">
        <Link to="/bless">Home</Link>
        <Link to="/bless/collections">Collection</Link>
        <Link onClick={handleContactClick}>Contact Us</Link>

        {/* Cart Icon */}
        <div className="cart-container" onClick={() => setCartOpen(true)}>
          <FaShoppingCart className="cart-icon" />
          {cartItems.length > 0 && <span className="cart-count">{cartItems.length}</span>}
        </div>
      </div>
      {/* Cart Slider */}
      {cartOpen && (
        <CartSlider cartItems={cartItems} onClose={() => setCartOpen(false)} />
      )}
    </nav>
  );
};
export default BlessnavBar